import { Alert } from '@mui/material';
import { Fragment, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Link, useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import { InfoButtonIcon } from 'src/component/Buttons/InfoButtonIcon';
import { useProjects } from 'src/hooks/useProjects';
import { useUser } from 'src/hooks/useUser';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../breadcrumb';
import styles from '../../styles/style-project.module.scss';
import ProjectColumns from './table-header/project-columns';

const NUMBER_OF_PROJECTS_PER_PAGE = 15;

const ListProjectPage = (props) => {
  const httpClient = useHttpClient(true);
  const history = useHistory();
  const [search, setSearch] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const projectPerPage = NUMBER_OF_PROJECTS_PER_PAGE;
  const pagesVisited = pageNumber * NUMBER_OF_PROJECTS_PER_PAGE;
  const { projects, refetchProjects } = useProjects();


  let data = [];

  const { user } = useUser();

  const deleteProject = async (projectId) => {
    await httpClient.current?.delete(`/api/project/${projectId}`);
    refetchProjects();
  };

  projects
    .filter((project) => project.name.toUpperCase().includes(search.toUpperCase()))
    .slice(pagesVisited, pagesVisited + projectPerPage)
    .map((project) => {
      let action = (
        <div>
          <Link to={`${process.env.PUBLIC_URL}/project/detail/${project.id}`}>
            <InfoButtonIcon title={props.t('more_details')} className={`fa fa-eye ${styles['action']}`} />
          </Link>
          <span>
            <Link to={`${process.env.PUBLIC_URL}/project/edit/${project.id}`}>
              <EditButtonIcon title={props.t('edit_Project')} className={`fa fa-pencil ${styles['action']}`} />
            </Link>
          </span>
          {user?.isSuperAdmin && (
            <span>
              <DeleteButtonIcon
                title={props.t('delete_p')}
                onClick={() =>
                  SweetAlert.fire({
                    title: props.t('you_delete'),
                    text: props.t('not_recover'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: props.t('cancel'),
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.value) {
                      deleteProject(project.id);
                      SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                    } else {
                      SweetAlert.fire(props.t('isNotDeleted'));
                    }
                  })
                }
                className={`fa fa-trash ${styles['trash']}`}
              />
            </span>
          )}
        </div>
      );

      return data.push({
        name: project.name,
        startDate: project.startDate,
        endDate: project.endDate,
        description: project.description,
        action: action,
      });
    });
    const changePage = ({ selected }) => {
      setPageNumber(selected);
    };

    const pageCount = Math.ceil(
      (search === '' ? projects : projects.filter((project) => project.name.includes(search))).length / projectPerPage
    );
    
  return (
    <div>
      <Fragment>
        <Breadcrumb parent={props.t('list_projects')} url={'project/list'} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div className="float-right">
                    {user?.isSuperAdmin && (
                      <Button outline color="success" onClick={() => history.push('/project/add')}>
                        {props.t('create_Project')}
                      </Button>
                    )}
                  </div>
                </CardHeader>
                <CardBody>
                  <input
                    className="form-control col-md-6 mb-2 "
                    onChange={(event) => {
                      setSearch(event.target.value);
                      changePage({ selected: 0 });
                    }}
                    value={search}
                    placeholder={props.t('search_unit')}
                  />
                  {data.length === 0 ? (
                    <Alert variant="outlined" severity="info">
                      {props.t('no_project')}
                    </Alert>
                  ) : (
                    <ProjectColumns data={data} />
                  )}
                  <br />
                  <div className="float-right">
                    {projects.length > NUMBER_OF_PROJECTS_PER_PAGE && (
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={styles['paginationButton']}
                        previousLinkClassName={styles['previousBtn']}
                        nextLinkClassName={styles['nextBtn']}
                        disabledClassName={styles['paginationDisabled']}
                        activeClassName={styles['paginationActive']}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </div>
  );
};
export default translate(ListProjectPage);
